export default {"src":"/_next/static/media/white-rice.bfed4591.svg","height":32,"width":72,"blurWidth":0,"blurHeight":0};